import React from "react";
import { List, Avatar } from 'antd';
import styles from "../../Header/Header.module.css";
import { FileTextTwoTone } from "@ant-design/icons";

export function SchematicList( { schematic_list, onImport, removeSchematicDocument } ) {
	return (
			<div className={ styles.schematiList_container }>
				<List
						dataSource={ schematic_list }
						renderItem={ item => {
							return (
									<List.Item className={ styles.item_list }
											   onClick={ () => onImport(item) }
											   actions={ [
												   <img onClick={ ( e ) => {
													   e.stopPropagation();
													   removeSchematicDocument(item)
												   } }
														className={ styles.trash_box }
														src="https://img.icons8.com/fluent/344/delete.png"
														alt=""/>,
											   ] }
									>
										<List.Item.Meta
												avatar={ <Avatar className={ styles.document_icon }
																 icon={ <FileTextTwoTone/> }/> }
												title={ item.document_name }
										/>
									</List.Item>
							)
						} }/>
			</div>
	)
}
